module.exports = __webpack_public_path__ + "img/workout-notebook_B095LH5H9B.72fc5c74.jpg";